<template>
  <div class="noAuth">你妹权限</div>
</template>

<script lang="ts">
document.title="无权限"
</script>
